import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastService } from './core/toast.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  template: `
    <router-outlet />

    <!-- Toast host is fixed, so an arriving toast never shifts page content. -->
    <div class="toasts" role="status" aria-live="polite">
      @for (toast of toasts.toasts(); track toast.id) {
        <div
          class="toast"
          [class.toast--error]="toast.tone === 'error'"
          [class.toast--ok]="toast.tone === 'ok'"
        >
          <span class="grow">{{ toast.message }}</span>
          <button type="button" class="btn-icon" (click)="toasts.dismiss(toast.id)" aria-label="إغلاق التنبيه">
            <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor"
                 stroke-width="2" stroke-linecap="round" aria-hidden="true">
              <path d="M18 6 6 18M6 6l12 12" />
            </svg>
          </button>
        </div>
      }
    </div>
  `,
})
export class App {
  protected readonly toasts = inject(ToastService);
}
